import React, { useState } from 'react';
import {
  TextField,
  FormControl,
  FormHelperText,
  Box,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from '@material-ui/core';
import { IconContext } from 'react-icons';
import { MdExpandMore } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';

import { DSLink, DSText } from '@engenharia/ds-react';

import Logo from '../../components/molecules/Logo';
import MetaHeader from '../../components/MetaHeader';
import { Container, Card, CardHeader, Form } from './styles';
import { mailValidation } from '../../utils/validations';
import api from '../../services/api';
import Notification from '../../components/Notification';
import Button from '../../components/atoms/Button';
import Header from '../../components/Header';
import { transcodeLanguage } from '../../utils/language';
import { getLanguage } from '../../services/auth';

export default function ConfirmedEmail() {
  const { t } = useTranslation();

  return (
    <>
      <Header positionFixed />
      <Container>
        <MetaHeader
          title="mLabs | Gestão de redes sociais"
          description="mLabs - Gestão de Redes sociais | Confirmação de email"
        />
        <Box>
          <Logo />
          <Box my={8} display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center">
            <Box mx={2} component={Card}>
              <CardHeader>
                <DSText variant="h4" weight={400} color="primary">
                  {t('confirmed-email.title')}
                </DSText>
              </CardHeader>
              <DSText variant="body2" weight={400} color="textSecondary">
                {t('confirmed-email.description')}
              </DSText>
              <Box display="flex">
                <Form action="/" method="get">
                  <Button
                    mt={4}
                    type="submit"
                    id="btnSubmit"
                    data-testid="formSubmit"
                    color="primary"
                  >
                    {t('confirmed-email.link-login')}
                  </Button>
                </Form>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
}
